// src/AuthCheck.js
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthProvider } from 'react-admin';

const AuthCheck = ({ children }) => {
  const authProvider = useAuthProvider();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    authProvider.checkAuth()
      .catch(() => {
        // Redirect to login but save the current location to return to after login
        navigate('/login', { state: { from: location.pathname }, replace: true });
      });
  }, [authProvider, navigate, location]);

  return children;
};

export default AuthCheck;